<template>
	<div class="variant">
		<div class="cells">
			<div class="cell-quantity">
				<counter v-bind="{props: {variantId: variant.id, productId: variant.product.id, rules: variant.rules}}"/>
			</div>
			<div class="cell-description" v-text="variant.description"/>
			<div class="cell-price" v-text="price"/>
			<div class="cell-total" v-text="totalPrice"/>
			<a class="cell-remove" @click="remove">
				<div class="icon" v-html="require('@/assets/icons/times-regular.svg')"/>
			</a>
		</div>
	</div>
</template>

<script>
import counter from "@/components/counter/mini.vue";
import {price} from "@/modules/utils";

export default {
	components: {counter},
	props: {
		id: {type: Number, required: true},
		variant: {type: Object, required: true},
		quantity: {type: Number, required: true},
		total_price: {type: Number, required: true}
	},
	computed: {
		totalPrice: (t) => price(t.total_price),
		price: (t) => price(t.variant.price)
	},
	methods: {
		remove() {
			this.$store.dispatch("cart/removeItem", {itemId: this.id});
		}
	}
};
</script>

<style lang="scss" scoped>
.variant {
	.cells {
		font-size: 12px;

		.cell {
			&-quantity {
				width: 55px;
			}
			&-description {
				width: 120px;
			}
			&-price {
				margin-left: auto;
			}
			&-remove {
				.icon {
					/deep/ svg {
						width: 6px;
						height: 10px;
					}
				}
			}
		}
	}
}
</style>
